import React, { ReactNode } from 'react'
import { connect, DispatchProp } from 'react-redux'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'
import { AnyAction } from 'redux'
import { Page, Spinner } from '../../../components'
import { images } from '../../../images'
import { appsShowRefundsSectionSelected } from '../../../helpers/app'
import { urls } from '../../../routing'
import { LiteralsService } from '../../../services'
import { fetchRefundedReservationsAction, setQrCodeAndDetails, setSelectedReservationModalAction } from '../../../store/actions'
import { IStoreState } from '../../../store/states'
import { Card } from '../Reservations/Card'
import StyledSection from './styles'
import { AuthenticatedRoutable, IReservation } from '../../../models'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  refundedReservations: IReservation[]
  isFetchingRefundedReservations: boolean
}

class RefundedReservations extends AuthenticatedRoutable<IProps> {
  private get emptyReservations(): ReactNode {
    return (
      <div className="empty-reservations">
        <img src={ images['noReservations'] } alt={ LiteralsService.get('noRefunds') }/>
        <h3>{ LiteralsService.get('noRefunds', true) }</h3>
      </div>
    )
  }

  private get reservationsContent(): ReactNode {
    const { refundedReservations, isFetchingRefundedReservations } = this.props

    if (isFetchingRefundedReservations) {
      return (
        <article className="spinner-container">
          <Spinner />
        </article>
      )
    } else {
      if (!refundedReservations.length) return this.emptyReservations
      return refundedReservations.map((reservation, i) => (
        <Card
          key={ i }
          reservation={ reservation }
          onClick={ () => this.goToReservationDetails(reservation) }
          onFavoriteClick={ () => this.handleOpenFavoriteModal(reservation) }
          onQRClick={ () => this.handleOpenQRModal(reservation) }
        />
      ))
    }
  }

  public componentDidMount() {
    super.componentDidMount()
    this.props.dispatch(fetchRefundedReservationsAction())
  }

  public render(): ReactNode {

    const { history } = this.props

    return (
      <Page className="authenticated">
        <StyledSection>
          <nav className="tabs">
            <div onClick={ () => history.push(urls.reservations) }>
              <span>{ LiteralsService.get('nextReservations', true) }</span>
            </div>
            <div className="divider" />
            <div onClick={ () => history.push(urls.pastReservations) }>
              <span>{ LiteralsService.get('pastReservations', true) }</span>
            </div>
            { appsShowRefundsSectionSelected?.show &&
              <>
                <div className="divider" />
                <div className="active">
                  <span>{ LiteralsService.get('refunds', true) }</span>
                </div>
              </>
            }
          </nav>
          <div className="reservations">
            { this.reservationsContent }
          </div>
        </StyledSection>
      </Page>
    )
  }

  private goToReservationDetails = (reservation: IReservation) => {
    this.props.history.push(
      `${ urls.reservationDetails }/${ reservation.id }`,
      { id: reservation.id, cancelled: reservation.cancelled, refunded: !!reservation.refundId }
    )
  }

  private handleOpenFavoriteModal = (reservation?: IReservation) => {
    this.props.dispatch(setSelectedReservationModalAction(reservation ?? null))
  }

  private handleOpenQRModal = (reservation: IReservation) => {
    const { dispatch } = this.props
    dispatch(setQrCodeAndDetails(reservation))
  }
}

const mapStateToProps = ({ reservations }: IStoreState) => ({
  refundedReservations: reservations.refundedReservations,
  isFetchingRefundedReservations: reservations.isFetchingRefundedReservations
})

export default withRouter(connect(mapStateToProps)(RefundedReservations))
